export class Defines  {
    static ALLY_RATIO = 0.10; 
    static ENEMY_RATIO = 0.06;
    static BULLET_RATIO = 0.06;     
   
}

export enum Animations {
    ANIMATIONS_EXPLOTION = 0
}

export enum ActorState {
    IDDLE_STATE = 0,
    UP_STATE ,
    DOWN_STATE,
    LEFT_STATE,
    RIGTH_STATE,
    EXPLOTION_STATE,
    DELETED_STATE,    
}


// WEBPACK FOOTER //
// D:/xamppabeel/htdocs/Angular2Projects/CanvasSVG/src/app/Screen/Defines.ts